module.exports = __webpack_public_path__ + "img/logo.7c2e21bb.png";